<article class="product-card">
  <a
    class="product-card-link"
    (click)="navigateTo($event)"
    [href]="`/pia/${this.countryID()}/${this.languageID()}/${this.year()}/product/${this.id()}`"
  >
    <div class="favorites-container">
      <button
        class="favorites-btn icon-only-button"
        [ngClass]="[favoriteActive() ? 'blacken' : '']"
        (click)="handleFavorites(id())"
        type="button"
      >
        <claas-icon
          [id]="''"
          [iconId]="'649123'"
          [namespace]="'storybook'"
          [iconStyle]="'bold'"
          [size]="24"
          [alt]=""
          [iconName]="'favorites'"
          [removeDefaultColor]="true"
          [class]="'favorites-icon'"
        >
        </claas-icon>
      </button>
    </div>
    <img
      [src]="config.piaAPIOrigin + '/' + imgUrl() | authImage"
      loading="lazy"
      alt="{{
        'pia.shared.productImageAltDescription' | translate: { text: title() }
      }}"
      class="product-image"
    />
    <div class="product-card-description">
      <h3 class="product-card-title font-2xl">{{ title() }}</h3>
      <p class="product-card-info font-m">{{ text() }}</p>
    </div>
  </a>
</article>
